var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#183029",
    "data-name": "Group 1606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55 1H7.94L6.78 4.58H3l-.5 1.53H7.9z",
    "data-name": "Path 2770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.47 6.1l-.5-1.52H18.2L17.05 1h-1.61l1.66 5.1z",
    "data-name": "Path 2771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 19.97l1.3-.94-1.16-3.58 3.04-2.2-.5-1.54-4.34 3.16z",
    "data-name": "Path 2772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22.6l1.22-.9 1.22-.88-2.1-6.48 5.5-4-.46-1.43-.47-1.44h-6.8L14.01 1h-3.03l-2.1 6.47h-6.8L1.6 8.91l-.47 1.44 5.5 4-2.1 6.47 1.23.89 1.22.88 5.5-4zm-9.55-8.84L1.9 9H10l2.5-7.7L15 9h8.08l-6.54 4.76 2.5 7.7-6.53-4.74-.02-.02-6.55 4.76z",
    "data-name": "Path 2773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54 24.38l1.3-.95-4.35-3.15-4.34 3.16 1.3.94 3.04-2.2z",
    "data-name": "Path 2774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.7 11.7l-.5 1.54 3.04 2.21-1.16 3.58 1.3.95 1.66-5.11z",
    "data-name": "Path 2775"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.bd712507.svg";
export { ForwardRef as ReactComponent };